import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
import addHours from 'date-fns/addHours'

const DEFAULT_TIMEZONE_OFFSET = 8

export function parseDatetime(dateString, timezoneOffset = DEFAULT_TIMEZONE_OFFSET) {
  return addHours(parseISO(dateString), timezoneOffset)
}

export function formatDatetime({ date, timezoneOffset, dateFormat = 'yyyy-MM-dd HH:mm:ss' }) {
  return format(parseDatetime(date, timezoneOffset), dateFormat)
}
